export const PERIZIE_GET = "PERIZIE_GET";
export const PERIZIE_GET_SUCCESS = "PERIZIE_GET_SUCCESS";
export const PERIZIE_DELETE = "PERIZIE_DELETE";